// src/core/challenge.ts
// Encode / decode / compare helpers for the "Challenge a friend" feature.
// URL format: https://barve.app/?c=DAY.SCORE (plain integers, no obfuscation).

import type { ChallengeContext } from '../types';

export function encodeChallenge(day: number, score: number): string {
  return `${day}.${score}`;
}

export function decodeChallenge(param: string): ChallengeContext | null {
  if (!param) return null;
  const parts = param.split('.');
  if (parts.length !== 2) return null;
  const day = Number(parts[0]);
  const score = Number(parts[1]);
  if (!Number.isInteger(day) || !Number.isInteger(score)) return null;
  if (day < 0 || score < 0 || score > 100) return null;
  return { day, score };
}

export function parseChallengeFromUrl(
  search: string,
  todayDayNumber: number,
): ChallengeContext | null {
  const params = new URLSearchParams(search);
  const raw = params.get('c');
  if (!raw) return null;
  const ctx = decodeChallenge(raw);
  if (!ctx) return null;
  if (ctx.day !== todayDayNumber) return null;
  return ctx;
}

export function challengeUrl(day: number, score: number): string {
  return `https://barve.app/?c=${encodeChallenge(day, score)}`;
}

export function challengeComparisonLine(
  playerScore: number,
  friendScore: number,
): string {
  const delta = playerScore - friendScore;
  if (delta === 0) return `You ${playerScore} \u2014 Friend ${friendScore} \u00b7 Tied`;
  const sign = delta > 0 ? '+' : '\u2212';
  const abs = Math.abs(delta);
  return `You ${playerScore} \u2014 Friend ${friendScore} (${sign}${abs})`;
}
